// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2UPBP","title":"AfterBackImages_title__1pWzc","images":"AfterBackImages_images__1ls6k"};